<template>
    <div class="help">
      <div class="wrap">
        <div class="banner">
            <h1>用户指南</h1>
            <h2>{{title}}</h2>
        </div>
        <search />
        <van-grid
            :column-num="3"
            :border="false"
        >
            <van-grid-item
                v-for="item in categories"
                :key="item.id"
                :icon="item.thumbnail.replace('mhelp','help')"
                :text="item.name"
                :to="'categories?id=' + item.id + '&title='+title"
            />
        </van-grid>
      </div>
        <p class="desc-text">*70mai®品牌致力于不断的改进产品，提高用户体验，设备和APP将会不断更新升级，请以实际操作页面为准。</p>
    </div>
</template>
 

<script>
import ClientApi from '@/assets/js/clientApi.js'
import search from "./search.vue";
import Vue from 'vue';
import { Toast, Grid, GridItem } from "vant";
Vue.use(Grid);
Vue.use(GridItem);
export default {
    name: "Index",
    components: {
        search
    },
    data () {
        return {
            title: '',
            id: this.$route.query.categories,
            categories: []
        };
    },
    created () {
        if (!this.id) {
            Toast('缺少参数');
            return
        }
        this.getCurrentCategories();
        this.getCategories();
    },
    methods: {
        async getCurrentCategories () {
            let [data] = await this.$http.get(
                "/wp-json/wp/v2/categories?include=" + this.id);
            if (!data) {
                Toast('当前分类不存在');
                return
            }
            document.title = data.name
            this.title = data.name
            ClientApi.getApi('setTitleJS', data.name)
        },
        async getCategories () {
            let data = await this.$http.get(
                "/wp-json/wp/v2/categories?include=" + this.id + "&orderby=id&per_page=1"
            );
            let url = "/wp-json/wp/v2/categories?parent=" + this.id + "&orderby=id&per_page=40"
            if (data[0].description) {
                url = "/wp-json/wp/v2/categories?parent=" + this.id + "&orderby=description&order=desc&per_page=40"
            }
            this.categories = await this.$http.get(url);
        }
    }
};
</script>
<style lang="scss" >
.help {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  .wrap{
    flex:1;
    .banner {
        height: 200px;
        margin: 24px;
        border-radius: 4px;
        background: url("../assets/banner@2x.png") no-repeat center center /
            100%;
        display: flex;
        flex-flow: column;
        justify-content: center;
        padding: 0px 0px 0px 24px;
        h1 {
            font-size: 44px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #222222;
            line-height: 60px;
            text-align: left;
            margin: 0px;
        }
        h2 {
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 40px;
            text-align: left;
            margin: 0px;
            padding-top: 8px;
        }
    }
    .van-grid-item__content {
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .van-grid-item__text {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
    }
    .van-grid-item__icon {
        font-size: 60px;
    }
  }
  .desc-text {
        margin: 36px 24px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #969696;
    }
}
@media screen and (min-width: 768px) {
    h1 {
        font-size: 42px !important;
    }
    h2 {
        font-size: 28px !important;
    }
    .banner {
        margin: 0px !important;
        padding-bottom: 0px !important;
        height: auto !important;
    }
    .desc-text {
        margin: 24px 0px !important;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
    }
}
</style>
